module.exports = __webpack_public_path__ + "img/PM.66877afd.png";